import { ActivityBannerType, ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { ActivitySearchStore } from '../../../stores';

export const getBannerByType = (
  activitySearchStore: ActivitySearchStore,
  bannerType: ActivityBannerType
): ActivityDestinationViewSearch.Banners[] | null => {
  if (
    activitySearchStore.searchSummary &&
    activitySearchStore.searchSummary.aboveTheFold &&
    activitySearchStore.searchSummary.aboveTheFold.banners &&
    activitySearchStore.searchSummary.aboveTheFold.banners.length > 0
  ) {
    const banners = activitySearchStore.searchSummary.aboveTheFold.banners.filter(
      (banner: ActivityDestinationViewSearch.Banners) => banner.type === bannerType
    );

    return banners;
  }

  return null;
};
